// import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
// import authService from "./authService"
// import { VerifyOTPDTO } from "../../dtos/doctor"
// import { LoginDTO } from "../../dtos/auth"

// const initialState = {
//     otpPayload: null,
//     loginPayload: null,

//     isLoginError: false,
//     isOTPError: false,

//     isSuccess: false,
//     isLoading: false,

//     loginMessage: "",
//     verifyMessage: "",
// }


// export const login = createAsyncThunk("api/admin/login", async (doctor: LoginDTO, thunkAPI) => {
//     try {
//         return await authService.login(doctor)
//     } catch (error: any) {
//         const message =
//             (error.response &&
//                 error.response.data &&
//                 error.response.data.message) ||
//             error.message ||
//             error.toString()
//         return thunkAPI.rejectWithValue(message)
//     }
// })



// export const authSlice = createSlice({
//     name: "authSlice",
//     initialState,
//     reducers: {
//         reset: () => initialState,
//     },
//     extraReducers: (builder) => {
//         builder

//             .addCase(login.pending, (state) => {
//                 state.isLoading = true
//             })
//             .addCase(login.fulfilled, (state, action) => {
//                 state.isLoading = false
//                 state.isSuccess = true
//                 state.loginMessage = ""
//                 state.loginPayload = action.payload
//             })
//             .addCase(login.rejected, (state, action: PayloadAction<any>) => {
//                 state.isLoading = false
//                 state.isLoginError = true
//                 state.loginMessage = action.payload
//                 state.loginPayload = null
//             })
//     }
// })

// export const { reset } = authSlice.actions
// export default authSlice.reducer


import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import authService from "./authService"
import { VerifyOTPDTO } from "../../dtos/doctor"
import { ForgetPasswordDTO, ForgetPasswordOtpDTO, LoginDTO, ResetPasswordDTO, SignUpDTO, VerifyOTPSignUpDTO, UpdatePasswordDTO } from "../../dtos/auth"

const initialState = {
    otpPayload: null,
    loginPayload: null,

    isLoginError: false,
    isUpdatePasswordError: false,
    isUpdatePasswordSuccess: false,
    isOTPError: false,

    isSuccess: false,
    isLoading: false,

    loginMessage: "",
    verifyMessage: "",
    updatePasswordMessage: "",
}


// export const login = createAsyncThunk("api/auth/send-verification-code", async (doctor: LoginDTO, thunkAPI) => {
//     try {
//         return await authService.login(doctor)
//     } catch (error: any) {
//         const message =
//             (error.response &&
//                 error.response.data &&
//                 error.response.data.message) ||
//             error.message ||
//             error.toString()
//         return thunkAPI.rejectWithValue(message)
//     }
// })


export const login = createAsyncThunk("/api/pharmacy/login", async (dto: LoginDTO, thunkAPI) => {
    try {
        return await authService.login(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const forgetPassword = createAsyncThunk("/api/pharmacy/forget_password", async (dto: ForgetPasswordDTO, thunkAPI) => {
    try {
        return await authService.forgetPassword(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const forgetPasswordOtp = createAsyncThunk("/api/pharmacy/otp_verification", async (dto: ForgetPasswordOtpDTO, thunkAPI) => {
    try {
        return await authService.forgetPasswordOtp(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const resetPassword = createAsyncThunk("/api/pharmacy/reset_password", async (dto: ResetPasswordDTO, thunkAPI) => {
    try {
        return await authService.resetPassword(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateInternalPassword = createAsyncThunk("/api/pharmacy/update_internal_password", async (dto: UpdatePasswordDTO, thunkAPI) => {
    try {
        return await authService.updateInternalPassword(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const signup = createAsyncThunk("/api/pharmacy/signup", async (dto: SignUpDTO, thunkAPI) => {
    try {
        return await authService.signUp(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
export const logout = createAsyncThunk("/api/pharmacy/logout", async ({ bearerToken, staff_token }: { bearerToken: string; staff_token: string },  thunkAPI) => {
    try {
        return await authService.logout(bearerToken , staff_token)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const verifySignUpOTP = createAsyncThunk("/api/pharmacy/verify_otp", async (dto: VerifyOTPSignUpDTO, thunkAPI) => {
    try {
        return await authService.signUpVerifyOTP(dto)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const verifyOTP = createAsyncThunk("api/auth/verify-otp-code", async (doctor: VerifyOTPDTO, thunkAPI) => {
    try {
        return await authService.verifyOTP(doctor)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const authSlice = createSlice({
    name: "authSlice",
    initialState,
    reducers: {
        reset: () => initialState,
    },
    extraReducers: (builder) => {
        builder

            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.loginMessage = ""
                state.loginPayload = action.payload
            })
            .addCase(login.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false
                state.isLoginError = true
                state.loginMessage = action.payload
                state.loginPayload = null
            })
            .addCase(verifyOTP.pending, (state) => {
                state.isLoading = true
            })
            .addCase(verifyOTP.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.verifyMessage = ""
                state.otpPayload = action.payload
            })
            .addCase(verifyOTP.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false
                state.isOTPError = true
                state.verifyMessage = action.payload
                state.otpPayload = null
            })
            .addCase(updateInternalPassword.pending, (state) => {
                state.isLoading = true
                state.isUpdatePasswordSuccess = false
                state.isUpdatePasswordError = false
            })
            .addCase(updateInternalPassword.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isUpdatePasswordSuccess = true
                state.isUpdatePasswordError = false
                state.updatePasswordMessage = ""
            })
            .addCase(updateInternalPassword.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false
                state.isSuccess = false
                state.isUpdatePasswordSuccess = false
                state.isUpdatePasswordError = true
                state.updatePasswordMessage = "Error Updating Password"
                state.updatePasswordMessage = action.payload
            })
            .addCase(resetPassword.pending, (state) => {
                state.isLoading = true
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isUpdatePasswordSuccess = true
                state.isUpdatePasswordError = false
                state.updatePasswordMessage = ""
            })
            .addCase(resetPassword.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false
                state.isUpdatePasswordSuccess = false
                state.isUpdatePasswordError = true
                state.updatePasswordMessage = "Error Updating Password"
                state.updatePasswordMessage = action.payload
            });
    }
})

export const { reset } = authSlice.actions
export default authSlice.reducer